import { inject, observer } from "mobx-react";
import { Component } from "react";
import { FormattedMessage } from "react-intl";
import { injectIntl, type IntlShape } from "react-intl";
import { compose } from "nvent-web/utils/compose";
import PageTitle from "nvent-web/App/components/PageTitle";
import AppStore from "nvent-web/stores/App";
import { PromotionsStore } from "nvent-web/stores/Promotions";
import { UserStore } from "nvent-web/stores/User";
import { Banner } from "./components/Banner/Banner";
import { CatalogBar } from "./components/CatalogBar/CatalogBar";
import { SignUpTodayBanner } from "./components/SignUpTodayBanner/SignUpTodayBanner";
import { ProBenefits } from "./components/ProBenefits/ProBenefits";
import { Promotion } from "./components/Promotion/Promotion";
import { GetStarted } from "./components/GetStarted/GetStarted";

import style from "./ProPageCommon.module.scss";

interface NonCertifiedProPagePropsInner {
  intl: IntlShape;
  user: UserStore;
  app: AppStore;
  promotions: PromotionsStore;
}

class NonCertifiedProPageInner extends Component<NonCertifiedProPagePropsInner> {
  render() {
    const { promotions, user } = this.props;

    const generalPromotions = promotions
      .promotionsByCountryCode(user.companyAddress.countryCode)
      .filter(
        (promotion) =>
          promotion.availability === "only_non_certified_pro" &&
          promotion.status === "active"
      );

    return (
      <>
        <PageTitle>
          <FormattedMessage id="certifiedPage.nonCertified.title" />
        </PageTitle>

        <section className={style.wrapper}>
          <div className={style.wrapperColumn}>
            <Banner>
              <span>
                <FormattedMessage id="certifiedPage.nonCertified.banner" />
              </span>
            </Banner>
          </div>
          <div className={style.wrapperColumn}>
            {!promotions.arePromotionsLoading &&
              generalPromotions.length === 0 && (
                <FormattedMessage id="certifiedPage.certified.activePromotions.empty" />
              )}
            {!promotions.arePromotionsLoading &&
              generalPromotions.map((promotion) => (
                <Promotion promotion={promotion} key={promotion.id} />
              ))}
          </div>
        </section>

        <section className={style.wrapper}>
          <CatalogBar />
        </section>

        <section className={style.wrapper}>
          <ProBenefits />
        </section>

        <section className={style.wrapper}>
          <SignUpTodayBanner countryCode={user.companyAddress.countryCode} />
        </section>

        <section className={style.wrapper}>
          <GetStarted />
        </section>
      </>
    );
  }
}

export const NonCertifiedProPage = compose(
  inject("user", "app", "promotions"),
  injectIntl,
  observer
)(NonCertifiedProPageInner);
